import React from "react";
import { Box, Container } from "@mui/system";
import { Skeleton, Typography } from "@mui/material";

export default function Layout2Section1({ acf, ...props }) {
  return (
    <Box
      sx={{
        backgroundImage: `url(${acf?.background_image.url})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        // height: "50vh",
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(90deg, rgba(13,96,168,1) 33%, rgba(0,0,0,0) 100%)",
          mixBlendMode: "multiply",
        }}
      />
      {props?.logo && props.logo !== "" && (
        <img
          src={props.logo}
          alt="logo"
          style={{
            width: "80px",
            marginLeft: "auto",
            position: "relative",
            zIndex: 1,
          }}
          id={"header-logo"}
        />
      )}

      <Container
        maxWidth="xl"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          color: "#fff",
          transform: "translateZ(1px)",
          pt: 6,
          pb: 12,
        }}
      >
        <Box
          sx={{
            width: {
              xs: "100%",
              md: "50%",
            },
          }}
        >
          {acf?.title && acf?.title !== "" ? (
            <Typography
              variant="h1"
              sx={{
                fontSize: "3.25rem",
                fontWeight: 600,
              }}
              dangerouslySetInnerHTML={{ __html: acf.title }}
            />
          ) : (
            <Skeleton
              sx={{
                maxWidth: "300px",
              }}
            />
          )}

          {acf?.subtitle && acf?.subtitle !== "" ? (
            <Typography
              variant="h2"
              sx={{
                fontSize: "3rem",
                fontWeight: 400,
                mb: "1rem",
                paddingBottom: "1rem",
              }}
              dangerouslySetInnerHTML={{ __html: acf.subtitle }}
            />
          ) : (
            <Skeleton
              sx={{
                maxWidth: "300px",
              }}
            />
          )}

          {acf?.description && acf?.description !== "" ? (
            <Typography
              variant="p"
              component="p"
              sx={{}}
              dangerouslySetInnerHTML={{ __html: acf.description }}
            />
          ) : (
            <Skeleton
              sx={{
                maxWidth: "300px",
              }}
            />
          )}
        </Box>
      </Container>
    </Box>
  );
}
